import { gql } from '@apollo/client';
const GET_USER_UNREAD_COUNTS = gql `
  query GetUserUnreadCounts {
    getUserUnreadCounts {
      conversationId
      count
    }
  }
`;
export default GET_USER_UNREAD_COUNTS;
